interface AreaTestimonialsProps {
  area: string;
}

export default function AreaTestimonials({ area }: AreaTestimonialsProps) {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      location: area,
      rating: 5,
      text: `Absolutely delighted with the painting work done on our home in ${area}. The team was professional, punctual, and the finish is flawless. Highly recommend their services!`,
      image: 'https://public.readdy.ai/ai/img_res/616f64abe1231b2d641fa3bf8980db1f.jpg',
    },
    {
      name: 'James Thompson',
      location: area,
      rating: 5,
      text: `Excellent service from start to finish. They transformed our ${area} property with their expert painting and decorating. The attention to detail was outstanding.`,
      image: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20man%20standing%20in%20home%20relaxed%20everyday%20clothing%20friendly%20expression%20candid%20snapshot%20style%20authentic%20real%20person%20informal%20setting&width=400&height=400&seq=area-casual-002&orientation=squarish',
    },
    {
      name: 'Emma Roberts',
      location: area,
      rating: 5,
      text: `We've used Brushour for multiple projects in our ${area} home. They're reliable, skilled, and always deliver exceptional results. Wouldn't use anyone else!`,
      image: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20woman%20at%20home%20relaxed%20everyday%20style%20warm%20smile%20candid%20snapshot%20authentic%20real%20person%20informal%20living%20room%20setting&width=400&height=400&seq=area-casual-003&orientation=squarish',
    },
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            What Our {area} Clients Say
          </h2>
          <p className="text-lg text-sky-600 font-medium">
            Real reviews from satisfied customers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-slate-50 p-8 rounded-lg shadow-lg"
            >
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">{testimonial.name}</h4>
                  <p className="text-sm text-slate-600">{testimonial.location}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">
                {testimonial.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}